export default __webpack_public_path__ + "static/media/FLM.59e83215.svg";